import { gql } from '__generated__';

export default gql(`
  query GetMessages($project_id: ID!, $page: Int, $per_page: Int, $search: String, $events: [ID!]) {
    project(id: $project_id) {
      id
      messages(page: $page, per_page: $per_page, events: $events, search: $search) {
        data {
          id
          title
          subject
          draft
          remaining_count
          scheduled_at
          last_sent_at
          event {
            id
            title
          }
        }
        current_page
        last_page
        per_page
        total
      }
    }
  }
`);
